// extracted by mini-css-extract-plugin
module.exports = {"badge":"AI_badge__eONwN","button":"AI_button__F_G82","heading":"AI_heading__aZk8P"};